import React, { Component } from "react";
import { connect } from "react-redux";
import AddressBookCompanyContactForm from "./form";
import { createAddressBookCompanyContact } from "../actions";
import { Form } from "react-final-form"
import SlidingPane from "modules/5_view_helpers/web/SlidingPane";
function mapStateToProps(state) {
return {};
}
class NewAddressBookCompanyContactSliding extends Component {
constructor(props) {
super(props);
this.submitForm = this.submitForm.bind(this);
this.successfullySubmitted = this.successfullySubmitted.bind(this);
this.state = {
isOpen:this.props.isOpen
}
}
componentDidUpdate(prevProps, prevState) {
const prevIsOpen = prevState.isOpen
const { isOpen } = this.props
if(prevIsOpen != isOpen){
this.setState({isOpen:isOpen})
}
}
submitForm(values) {
const createRequest = this.props.createAddressBookCompanyContact(values);
createRequest.then(this.successfullySubmitted)
}
successfullySubmitted() {
const { toggle } = this.props
toggle()
toastr.success("Created New Contact")
}
render() {
const { isOpen } = this.state
const { toggle } = this.props
return (
<SlidingPane isOpen={isOpen} onRequestClose={toggle} title="New Contact" width="50%">
				<Form
					component={AddressBookCompanyContactForm}
					formLabel="Create"
					onSubmit={this.submitForm} 
					cancelFunction={toggle}
					{...this.props}
				/>
</SlidingPane>
);
}
}
export default connect(mapStateToProps,{ createAddressBookCompanyContact })(NewAddressBookCompanyContactSliding);
